import { User } from "../api-interfaces";

export class LocalUser extends User {
  profileImage?: any;
}
